import React, { useEffect, useState } from 'react';
import { Layout } from '../components/common/Layout';
import { Button } from '../components/common/Button';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SEOHead } from '../components/seo/SEOHead';

// Effective date requested: today's date
const EFFECTIVE_DATE = '31 August 2025';

const TermsPage: React.FC = () => {
  const navigate = useNavigate();
  const [md, setMd] = useState<string>('');
  const [error, setError] = useState<string>('');

  useEffect(() => {
    let isMounted = true;
  // Load the terms markdown from public folder (stable path)
  fetch('/legal/terms.md')
      .then(async (res) => {
        if (!res.ok) throw new Error('Failed to load Terms document');
        const text = await res.text();
        if (isMounted) setMd(text);
      })
      .catch(() => {
        if (isMounted) setError('Terms document is temporarily unavailable.');
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Layout showHeader showFooter>
      <SEOHead
        title="Terms and Conditions - trAInedup.ai"
        description="Read the terms and conditions for using trAInedup.ai, our AI learning platform. Understand your rights and responsibilities as a user."
        canonical="https://trainedup.ai/terms"
      />
      <div className="max-w-3xl mx-auto py-16 px-4">
        <Button variant="outline" onClick={() => navigate(-1)} className="mb-6">
          Back
        </Button>
        <h1 className="text-3xl font-bold mb-2">Terms and Conditions</h1>
        <p className="text-sm text-neutral-500 mb-6">Effective date: {EFFECTIVE_DATE}</p>

        {error && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded text-red-700 text-sm">{error}</div>
        )}

        <div className="prose max-w-none prose-p:mb-4 prose-li:mb-2">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;
